import React, { useState, useMemo } from 'react';
import { useIntl } from 'umi';
import AllGameSelector from '@/pages/intelligence/components/AllGameSelector';
import { followSearchPullDown } from '@/pages/intelligence/services/following';
import type { GameSelectionProps } from './types';
import type { SelectGames } from '@/pages/intelligence/components/AllGameSelector/types';
import './index.scss';
import { Button } from 'tea-component';
import SvgIcon from '@home/components/SvgIcon';

/**
 * 通用游戏筛选器组件
 */
export default function GameSelection(props: GameSelectionProps) {
  const {
    checkedList, // 组件已勾选游戏列表
    params, // 外部传入组件接口调用参数
    onConfirm, // 游戏筛选器confirm的回调
    searchAllGamesApi, // 外部传入组件自定义获取数据的接口
    selectGameBtnText, // 外部传入组件按钮文案
    notSelectTips, // 外部传入组件空态文案
    chooseUpNum = 1000, // 游戏筛选勾选上限
    isStudio: propsIsStudio = false,
    fixedSelectionGame: fixedSelectionGameKeyList, // 禁止删除本游戏，固选游戏
    isBlueButton = false,
    hasShortCut = false,
    leftTitleKey = 'dbi_select_games',
    shortcutList,
    onShortcutClick,
    selectedShortcutActive,
    shortcutAddGame,
    isShowShortcutTitle,
    transferModalClassName,
    setSelectedShortcutActive,
    shortCutNameEn,
    entityKey = 'id',
  } = props;
  // console.log('GameSelectionGameSelection', props);

  // 中英翻译
  const { formatMessage } = useIntl();
  // 控制游戏筛选器弹窗是否显示
  const [allGamesvisible, setAllGamesvisible] = useState(false);
  // 固选的已选游戏
  // const [fixedSelectionGameEntities, setFixedSelectionGameEntities] = useState<SelectGames[]>([]);
  // 过滤掉固选的已选游戏
  // const [checkedListCur, setCheckedListCur] = useState<SelectGames[]>(checkedList);
  const [isGameEmpty, setIsGameEmpty] = useState(false);
  // 是否是studio页面
  const isStudio = useMemo(() => {
    if (
      (chooseUpNum === 9 && Array.isArray(fixedSelectionGameKeyList) && fixedSelectionGameKeyList?.length > 0) ||
      propsIsStudio
    ) {
      return true;
    }
    return false;
  }, [chooseUpNum, propsIsStudio, fixedSelectionGameKeyList]);

  // 空游戏显示文案
  const emptyGameAllText = useMemo(() => {
    return isStudio ? 'dbi_select_any_game' : 'dbi_all';
  }, [isStudio]);

  // 筛选器按钮展示内容，默认为All
  const [buttonLabel, setButtonLabel] = useState(formatMessage({ id: emptyGameAllText }));

  // 是否是studio页面,没有选择游戏
  const isStudioEmptyGame = useMemo(() => {
    return isGameEmpty && isStudio;
  }, [isGameEmpty, isStudio]);

  /**
   * 游戏筛选器confirm回调
   */
  const handleGameConfirm = (value: string[], checkedList: SelectGames[]) => {
    onConfirm instanceof Function && onConfirm(value, '', false, checkedList);
    setAllGamesvisible(false);
  };

  // 游戏筛选器关闭事件回调
  const handleClose = () => {
    setAllGamesvisible(false);
  };

  // 游戏筛选器打开事件回调
  const handleGameSelection = () => {
    setAllGamesvisible(true);
  };

  // 设置筛选器按钮文案显示内容方法
  const getButtonLabel = (lable: string) => {
    setButtonLabel(lable);
  };

  // 过滤掉要固选的已选游戏
  // useEffect(() => {
  //   if (Array.isArray(fixedSelectionGameKeyList) && fixedSelectionGameKeyList?.length > 0 && Array.isArray(checkedList)) {
  //     return checkedList?.filter((item: SelectGames) => fixedSelectionGameKeyList?.includes(item.id));
  //   }
  // }, [checkedList, fixedSelectionGameKeyList]);

  // 过滤掉要固选游戏，返回已选游戏
  const checkedListCur = useMemo(() => {
    if (Array.isArray(fixedSelectionGameKeyList) && fixedSelectionGameKeyList?.length > 0) {
      return checkedList?.filter((item: SelectGames) => !fixedSelectionGameKeyList?.includes(item.id));
    }
    return checkedList;
  }, [checkedList, fixedSelectionGameKeyList]);

  // 过滤掉要固选的已选游戏
  const fixedSelectionGameEntities = useMemo(() => {
    if (Array.isArray(fixedSelectionGameKeyList) && fixedSelectionGameKeyList?.length > 0) {
      return checkedList?.filter((item: SelectGames) => fixedSelectionGameKeyList?.includes(item.id));
    }
    return [];
  }, [checkedList, fixedSelectionGameKeyList]);

  // console.log('checkedListCurcheckedListCur', checkedListCur);

  return (
    <>
      {/* 游戏筛选器按钮内容 */}

      <div className="tea-dropdown search-item dbi-region-dropdown size-m game-selection-btn">
        {isBlueButton ? (
          <Button type="primary" onClick={() => handleGameSelection()}>
            <SvgIcon className="dbi-swiper-arrow" type={'icon_add_game'} />
            {formatMessage({ id: 'dbi_game_selection' })}
          </Button>
        ) : (
          <div className="tea-dropdown__header tea-dropdown-btn" onClick={() => handleGameSelection()}>
            <div className="tea-dropdown__value">
              <div className="dbc-region-select-button-wrap" id="game-selection-btn">
                <span className="select-button-text">
                  {formatMessage({
                    id: selectGameBtnText ? selectGameBtnText : 'dbi_game',
                  })}
                </span>
                <span className={`select-button-value ${isStudioEmptyGame ? 'dropdown-value-placeholder' : ''}`}>
                  {buttonLabel}
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* 游戏筛选器打开弹窗内容 */}
      <AllGameSelector
        entityKey={entityKey}
        visible={allGamesvisible}
        title={formatMessage({ id: leftTitleKey })}
        selectedGameList={checkedListCur}
        pleaseSelectTips={formatMessage({ id: 'dbi_please_a_select_game' })}
        searchPlaceholder={formatMessage({ id: 'dbi_search_any_game' })}
        rightCellTitle={formatMessage({ id: 'dbi_games' })}
        keywordsFetcher={followSearchPullDown}
        onConfirm={handleGameConfirm}
        onClose={handleClose}
        getButtonLabel={getButtonLabel}
        tipText={
          formatMessage({ id: 'dbi_Choose_up_to_games' }) +
          chooseUpNum +
          formatMessage({ id: 'dbi_Choose_up_to_games_end' })
        }
        searchAllGamesApi={searchAllGamesApi}
        notSelectTips={notSelectTips}
        params={params}
        chooseUpNum={chooseUpNum}
        fixedSelectionGameKeyList={fixedSelectionGameKeyList}
        fixedSelectionGameEntities={fixedSelectionGameEntities}
        emptyGameAllText={emptyGameAllText}
        setIsGameEmpty={setIsGameEmpty}
        hasShortCut={hasShortCut}
        shortcutList={shortcutList}
        onShortcutClick={onShortcutClick}
        selectedShortcutActive={selectedShortcutActive}
        shortcutAddGame={shortcutAddGame}
        isShowShortcutTitle={isShowShortcutTitle}
        transferModalClassName={transferModalClassName}
        setSelectedShortcutActive={setSelectedShortcutActive}
        shortCutNameEn={shortCutNameEn}
      />
    </>
  );
}
